/**
 * Правила названия варианта плана — ОДНИ на создание и переименование.
 *
 * Живут отдельным модулем, а не внутри диалогов, по двум причинам:
 *   • правило одно, а диалогов два («+ Новый вариант» и «Переименовать»), и
 *     разъехавшись однажды они дали бы запрет, который обходится соседней
 *     кнопкой — ровно то, чего просил не допустить founder 21.08;
 *   • проверить их можно функцией, без рендера: именно на этих правилах
 *     экран ловят на вранье («сохранил пробелы», «молча завёл второй
 *     „Вариант 1“»).
 *
 * Зеркало сервера. Тексты и нормализация ДОСЛОВНО те же, что в
 * `api/v1/planning.py` (и в партиал-uq `uq_scenarios_farm_season_norm_name`,
 * миграция 170). Это не дублирование ради дублирования: проверка здесь нужна
 * для мгновенного отказа без круговорота на сервер, а сервер остаётся
 * единственной настоящей защитой — от гонки двух вкладок и от курла мимо UI.
 */

/**
 * Как сравнивает сервер: регистр, пробелы по краям и ё/е — не различие.
 *
 * Двойной пробел ВНУТРИ имени сознательно не схлопывается («Вариант  1» и
 * «Вариант 1» — разные имена): нормализация обязана совпадать с выражением
 * uq-индекса на сервере, иначе фронт обещал бы отказ там, где сервер пропустит,
 * — или наоборот. Тот же компромисс живёт в AK-491.
 */
export function normalizeVariantName(name: string): string {
  return name.trim().toLowerCase().replace(/ё/g, 'е');
}

/** Столько же в `maxLength` поля ввода и в `_MAX_NAME_LEN` на сервере. */
export const VARIANT_NAME_MAX = 120;

export const VARIANT_NAME_TAKEN =
  'Вариант с таким именем уже есть в этом хозяйстве — выберите другое.';

/**
 * Что не так с введённым названием — текстом для человека, или `null`.
 *
 * `currentName` — имя редактируемого варианта: сохранение записи с её
 * собственным названием конфликтом не считается (иначе «Переименовать» нельзя
 * было бы закрыть, ничего не поменяв).
 *
 * ВАЖНО: функция ничего не «чинит» за пользователя. Пустое имя — отказ
 * словами, а введённый текст остаётся в поле: съесть ввод и молча закрыть
 * диалог — худшее, что можно сделать с человеком, который печатал.
 */
export function variantNameError(
  raw: string,
  existingNames: readonly string[],
  currentName?: string,
): string | null {
  const name = raw.trim();
  if (!name) return 'Название не может быть пустым';
  if (name.length > VARIANT_NAME_MAX) {
    return `Название длиннее ${VARIANT_NAME_MAX} символов — сократите его.`;
  }
  const norm = normalizeVariantName(name);
  if (currentName !== undefined && norm === normalizeVariantName(currentName)) return null;
  if (existingNames.some((n) => normalizeVariantName(n) === norm)) return VARIANT_NAME_TAKEN;
  return null;
}
